export const CLIENT_ID = '1bf93493830939d17cb3f119be8b766b'; // Use your client ID
export const REDIRECT_URI = `${window.location.protocol}//${window.location.host}`;



// WEBPACK FOOTER //
// ./src/constants/auth.js